__turbopack_context__.v({
  "flex": "LayoutGrid-module__MXPM6W__flex",
  "grid": "LayoutGrid-module__MXPM6W__grid",
  "gridAutoFit": "LayoutGrid-module__MXPM6W__gridAutoFit",
  "gridColumns": "LayoutGrid-module__MXPM6W__gridColumns",
  "justify-between": "LayoutGrid-module__MXPM6W__justify-between",
  "justify-center": "LayoutGrid-module__MXPM6W__justify-center",
  "justify-end": "LayoutGrid-module__MXPM6W__justify-end",
  "justify-start": "LayoutGrid-module__MXPM6W__justify-start",
});
